export const IMAGES = {
  heroBottle: "https://static.prod-images.emergentagent.com/jobs/9ada5201-3a08-458f-899f-75929e68a782/images/699793c743a4a51453f87d167297e5878c0bafb9854bd5fb142b220dd4d51940.jpeg",
  softgels: "https://static.prod-images.emergentagent.com/jobs/9ada5201-3a08-458f-899f-75929e68a782/images/9961d0a9df5effa5c0b651c3d72bd2aa78e1f93dd7b924d235824c79408d752c.jpeg",
  lifestyle: "https://images.unsplash.com/photo-1518708909080-704599b19972?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGxpZmVzdHlsZSUyMHNlcmVuZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjUwNzc5N3ww&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1587924656868-6fa1bfba7a64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlYWwlMjBsaXF1aWQlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NjUwNzc5N3ww&ixlib=rb-4.1.0&q=85",
};

export const PRICE_PER_BOTTLE = 38;
export const SHIPPING_FEE = 8;
export const NPN = "80075106";
export const OWNER_EMAIL = "hrally@yahoo.com";
export const CURRENCY = "CAD";

export const money = (n) => `$${Number(n).toFixed(2)}`;

export const discountRate = (qty) => (qty >= 6 ? 0.15 : qty >= 3 ? 0.1 : 0);

export const calcTotals = (qty) => {
  const subtotal = qty * PRICE_PER_BOTTLE;
  const rate = discountRate(qty);
  const discount = +(subtotal * rate).toFixed(2);
  const shipping = qty > 0 ? SHIPPING_FEE : 0;
  return { subtotal, discount, rate, shipping, total: +(subtotal - discount + shipping).toFixed(2) };
};

export const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};
